<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      Edit
      @if (item_title) {
        <p class="subtitle">{{item_title}}</p>
      }
    </ion-title>
    @if (online && !loading) {
      <ion-buttons slot="end">
        <ion-button (click)="update()">
          <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>

</ion-header>

<ion-content>

  @if (online && !loading) {
    <ion-grid class="form">
      <ion-row>
        <ion-col>
          <ion-grid class="fieldset">
            <ion-row>
              <ion-col>
                <ion-textarea #customer_note_input type="text" inputmode="text" [autoGrow]="true" maxlength="500" rows="5" labelPlacement="stacked" fill="outline" [(ngModel)]="params['customer_note']">
                  <div slot="label">Note for customer<ion-text class="optional">optional</ion-text></div>
                </ion-textarea>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-textarea type="text" inputmode="text" [autoGrow]="true" maxlength="500" rows="5" labelPlacement="stacked" fill="outline" [(ngModel)]="params['internal_note']">
                  <div slot="label">Internal note<ion-text class="optional">optional</ion-text></div>
                </ion-textarea>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

</ion-content>